import { Table, TableColumn, Select, Option } from 'element-ui'
import { Pagination as LPagination } from '@/components/index'
import ResourceSvc from '@/services/resource.svc.js';
import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';

const svc = new ResourceSvc();

export default {

    props: ['courseId'],
    name: 'AdminApplicationAnswers',
    components: {
        LPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.from, this.to)
        },
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            this.pagination.total = store.getters.getCourseAttendantsAnswersTotal;
            return store.getters.getCourseAttendantsAnswersTotal;
        }
    },
    data() {
        return {
            title: "Answer Tables",
            searchTimeout: null,
            isForcedLoad: false,
            savedSearchQuery: '',
            searchQuery: '',
            dataLoad: false,
            savedCurrentTypeId: 0,
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
                savedPageIndex: 0,
                savedPerPage: 0
            },
            usersSelectOption: [{ value: 0, label: "All" }],
            userForSearch: null,
            savedUserForSearch: null,
            tableColumns: [
                {
                    prop: 'name',
                    label: 'User Name',
                    minWidth: 150
                },
                {
                    prop: 'field',
                    label: 'Question',
                    minWidth: 300
                }
                //,
                //{
                //    prop: 'answer',
                //    label: 'Answer',
                //    minWidth: 300
                //}
            ],
            tableData: []
        }
    },
    methods: {
        queriedData(forced) {

            if (this.searchQuery != this.savedSearchQuery && !this.isForcedLoad && !forced) {
                var self = this;
                if (this.searchTimeout) {
                    return this.tableData;
                }
                else {
                    this.searchTimeout = setTimeout(function () { self.searchTimeout = null; self.queriedData(true) }, 750);
                    return this.tableData;
                }
            }
            if (this.dataLoad)
                return this.tableData;

            if (this.pagination.savedPageIndex == this.pagination.currentPage && this.pagination.perPage == this.pagination.savedPerPage &&
                this.searchQuery == this.savedSearchQuery && this.userForSearch == this.savedUserForSearch && !this.isForcedLoad)
                return this.tableData;

            return this.loadData()
        },
        loadData() {
            var conf = { courseId: this.courseId, take: this.pagination.perPage, skip: this.from, search: this.searchQuery, attendantId: this.userForSearch || 0 };
            if (conf.skip < 0) {
                conf.skip = 0;
            }

            while (this.pagination.total <= conf.skip && conf.skip) {
                this.pagination.currentPage--;
                conf.skip -= this.pagination.perPage;
                if (conf.skip < 0) {
                    conf.skip = 0;
                }
            }

            this.dataLoad = true;
            var self = this;

            svc.getCourseAttendancesAnswers(conf).then(response => {
                self.dataLoad = false;
                this.isForcedLoad = false;
                self.tableData = response.body.data;
                store.commit('setCourseAttendantsAnswersTotal', response.body.count);
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedUserForSearch = self.userForSearch;
                self.savedSearchQuery = self.searchQuery;

                return self.tableData;
            }, response => {
                self.tableData = [];
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedSearchQuery = self.searchQuery;
                self.savedUserForSearch = self.userForSearch;
                self.dataLoad = false;
                self.isForcedLoad = false;
                return [];
            });
        },
        createCsvOld() {
            var url =  "/api/Course/GetCourseAttendantsFile/?id=" + this.courseId;
            var link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", "attendants.xlsx");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        exportToExcel(attendace, answers) {
            if (attendace && attendace.length > 0) {
                var workbook = XLSX.utils.book_new();

                var ws = XLSX.utils.json_to_sheet(attendace, { skipHeader: true });
                XLSX.utils.book_append_sheet(workbook, ws, "Attendance");

                ws = XLSX.utils.json_to_sheet(answers, { skipHeader: true });
                XLSX.utils.book_append_sheet(workbook, ws, "Answers");
                XLSX.writeFile(workbook, "Course_Attendance.xlsx");
            }
            else {
                this.$notify({ message: "Something went wrong.", type: 'danger' });
            }
        },
        createCsv() {
            var self = this;
            if (self.courseId) {
                svc.getCourseAttendanceInfo(self.courseId)
                    .then(response => {
                        if (response.body.isSuccess) {
                            self.exportToExcel(response.body.outputData.attendance, response.body.outputData.answers)
                        }
                        else {
                            self.$notify({ message: "Something went wrong. Message: " + response.body.message, type: 'danger' });
                        }
                    }, () => {
                        self.$notify({ message: "Something went wrong.", type: 'danger' });
                    });
            }
        },
        loadAttendeesDropdown() {
            var that = this;
            var conf = { courseId: this.courseId }

            svc.getAttendancesForSearch(conf).then(response => {

                that.usersSelectOption = [{ value: 0, label: "All" }];
                response.body.data.forEach(function (el) {
                    if (!that.usersSelectOption.some(function (u) { return u.value === el.value }))
                        that.usersSelectOption.push(el);
                });

            }, response => { });
        }
    },
    mounted() {
        this.loadAttendeesDropdown();
    },
    created() {
        var self = this;
        EventBus.$on("application_answers_load", data => {
            self.loadAttendeesDropdown();
            self.loadData();
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/courses/course-details/application-answers/application-answers.js